import React, { useState, useRef } from 'react';
import { Box, useMediaQuery, useTheme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { ChecklistEditor, ChecklistEditorHandle } from './ChecklistEditor';
import { StepButtonBar } from '../../../EditLegalListWizard/StepButtonBar';
import UpdateConnectionInfo from '../../../UpdateConnectionWizard/UpdateConnectionInfo';
import { useAptorApi } from '../../../../../../../Api';
import { useApiValidationSnackbar } from '../../../../../../../Api/useValidationSnackbar';
import OurLawCheckListInfo from './OurLawCheckListInfo';

interface Step2EditChecklistProps {
  lawId: number;
  unitId: number;
  onBack: () => void;
  onCancel: () => void;
  onComplete: () => void;
  updateChecklistInfo?: any;
  currentStepName?: string;
  setUpdateChecklistInfo?: () => void;
}

const Step2EditChecklist: React.FC<Step2EditChecklistProps> = ({
  lawId,
  unitId,
  onBack,
  onCancel,
  onComplete,
  updateChecklistInfo,
  currentStepName,
  setUpdateChecklistInfo,
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isSaving, setIsSaving] = useState(false);
  const checklistEditorRef = useRef<ChecklistEditorHandle>(null);
  const { api, abortController } = useAptorApi();
  const { notifySuccess, notifyUnhandledException, notifyValidationErrors } = useApiValidationSnackbar();
  const paperPadding = isMobile ? theme.spacing(2) : theme.spacing(2);
  const handleSave = async () => {
    if (!checklistEditorRef.current) return;

    const saveData = checklistEditorRef.current.getSaveData();
    if (!saveData) return;

    setIsSaving(true);
    try {
      await api.invoke(
        (i) => i.updateCustomerLawChecklist(lawId, unitId, saveData).then(() => notifySuccess()),
        abortController.current,
        (errors) => notifyValidationErrors(errors),
        notifyUnhandledException
      );

      if (!abortController.current.signal.aborted) {
        onComplete();
      }
    } catch (error) {
      console.error('Save failed:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            minHeight: "350px",
            maxHeight: "500px",
            overflow: 'auto',
          }}
        >
          <ChecklistEditor
            ref={checklistEditorRef}
            lawId={lawId}
            unitId={unitId}
            onComplete={onComplete}
          />
        </div>

        {updateChecklistInfo && currentStepName && (
          <div
            style={{
              width: isMobile ? '100%' : 'calc(50% - 5px)',
              maxHeight: "500px",
              overflow: 'auto',
            }}
          >
            <OurLawCheckListInfo
              updateConnectionInfo={updateChecklistInfo}
              currentStepName={currentStepName}
              onUpdate={setUpdateChecklistInfo}
            />
          </div>
        )}
      </div>

      <Box>
        <StepButtonBar
          onCancel={() => { }}
          onBack={() => { }}
          onNext={handleSave}
          nextLabel="form.save"
          nextDisabled={isSaving}
          isLoading={isSaving}
          formatMessage={formatMessage}
          showBack={false}
        />
      </Box>
    </div>
    // <div style={{ width: '100%' }}>
    //   <div
    //     style={{
    //       display: 'flex',
    //       width: '100%',
    //       gap: '10px',
    //       flexDirection: isMobile ? 'column' : 'row',
    //       alignItems: 'stretch',
    //     }}
    //   >
    //     <div
    //       style={{
    //         width: isMobile ? '100%' : 'calc(100% - 5px)',
    //         flexShrink: 0,
    //         padding: isMobile ? theme.spacing(3) : theme.spacing(2),
    //         minHeight: '350px',
    //       }}
    //     >
    // <ChecklistEditor
    //   ref={checklistEditorRef}
    //   lawId={lawId}
    //   unitId={unitId}
    //   onComplete={onComplete}
    // />
    //     </div>
    //     {updateChecklistInfo && currentStepName && (
    //       <UpdateConnectionInfo
    //         updateConnectionInfo={updateChecklistInfo}
    //         currentStepName={currentStepName}
    //         onUpdate={setUpdateChecklistInfo}
    //       />
    //     )}
    //   </div>

    //   <Box>
    // <StepButtonBar
    //   onCancel={() => {}}
    //   onBack={() => {}}
    //   onNext={handleSave}
    //   nextLabel="form.save"
    //   nextDisabled={isSaving}
    //   isLoading={isSaving}
    //   formatMessage={formatMessage}
    //   showBack={false}
    // />
    //   </Box>
    // </div>
  );
};

export default Step2EditChecklist;
